module.exports = __webpack_public_path__ + "static/media/icon_service_on.a79e6d82.svg";